import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Label, CustomInput } from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import LoadingButton from '../../../UI/LoadingButton';
import Moment from 'moment';
import TimeSelector from '../../../UI/TimeSelector';
import { Alert, Dropdown } from '../../../UI/Common';
import MP from './MP';
import ReactSelect from '../../../UI/ReactSelect';

const groupHours = [
  { value: '1', label: 'Hour' },
  { value: '24', label: 'Day' },
  { value: '168', label: 'Week' },
  { value: '672', label: 'Month' },
];
const GroupStatusStatisticsPage = (props) => {
  const { t, isFetchingReport, groups, errors } = props;
  const form = {
    groupId: undefined,
    typeIds: [],
    groupHours: '1',
    fromDate: Moment().startOf('month').toDate(),
    toDate: new Date(),
    format: 'pdf',
  };
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onGetReport(values)}
        >
          {({
            values,
            errors,
            setFieldTouched,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <ReactSelect
                  required
                  containerStyle={{ width: '30%' }}
                  name="groupId"
                  label="Group"
                  options={groups}
                  value={values.groupId}
                  onChange={({ value }) => {
                    setFieldValue('groupId', value);
                  }}
                  valueKey="id"
                  labelKey="name"
                  invalid={touched.groupId}
                  error={errors.groupId}
                />
                <MP
                  groupId={values.groupId}
                  onSelect={(typeIds) => {
                    setFieldTouched('typeIds', false);
                    setFieldValue('typeIds', typeIds);
                  }}
                  invalid={errors.typeIds && touched.typeIds}
                  error={errors.typeIds}
                />
                <TimeSelector
                  onlyHour
                  onChange={(fromDate, toDate) => {
                    setFieldValue('fromDate', fromDate);
                    setFieldValue('toDate', toDate);
                  }}
                />
                <FormGroup>
                  <Label>{t('Group Statistics By')}</Label>
                  <div>
                    {groupHours.map((groupHour) => (
                      <CustomInput
                        key={groupHour.value}
                        type="radio"
                        id={`${groupHour.value}${groupHour.label}`}
                        value={groupHour.value}
                        label={t(groupHour.label)}
                        checked={values.groupHours === groupHour.value}
                        onChange={(e) =>
                          setFieldValue('groupHours', e.target.value)
                        }
                        inline
                      />
                    ))}
                  </div>
                </FormGroup>
                <div>
                  <LoadingButton
                    id="pdf-export"
                    classes="button button-primary mr-20"
                    loading={isFetchingReport}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'pdf');
                      handleSubmit();
                    }}
                  >
                    {t('PDF')}
                  </LoadingButton>
                  <LoadingButton
                    id="excel-export"
                    classes="button button-primary mr-20"
                    loading={isFetchingReport}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'excel');
                      handleSubmit();
                    }}
                  >
                    {t('Excel')}
                  </LoadingButton>
                  <LoadingButton
                    id="word-export"
                    classes="button button-primary"
                    loading={isFetchingReport}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'word');
                      handleSubmit();
                    }}
                  >
                    {t('Word')}
                  </LoadingButton>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(GroupStatusStatisticsPage);
